<header>

  <!-- ===================== RIDER ROUTE NAV ===================== -->
  <nav *ngIf="isRiderRoute"
       class="navbar navbar-expand-lg navbar-dark"
       [class.bg-dark]="!brandingPrimaryColor"
       [style.background-color]="brandingPrimaryColor || null"
       role="navigation"
       aria-label="Primary Navigation">

    <!-- Brand / Logo -->
    <a class="navbar-brand" style="cursor: pointer;" (click)="navigateToDashboard()">
      <img
        class="logo"
        [src]="brandingPrimaryLogo || 'assets/images/e-logo.png'"
        [alt]="(brandingAgencyName || 'Agency') + ' logo'"
        (error)="onLogoError($event)"
      />
    </a>

    <!-- Nav tabs -->
    <div class="navbar-nav-links">
      <a class="nav-tab" [class.active]="activeTab === 'applications'" (click)="setActiveTab('applications')" role="tab" tabindex="0" (keydown.enter)="setActiveTab('applications')">{{ translate('applications') }}</a>
    </div>

    <!-- Desktop user dropdown -->
    <div class="collapse navbar-collapse justify-content-end d-none d-lg-flex" id="navbarNavRider">
      <ul class="navbar-nav">
        <li class="nav-item dropdown user-container">
          <a
            style="display: flex; align-items: center;"
            class="nav-link"
            id="navbarDropdownRider"
            role="button"
            aria-haspopup="true"
            [attr.aria-expanded]="isDropdownOpen"
            [attr.aria-label]="'User menu for ' + givenName + ' ' + familyName"
            tabindex="0"
            (keydown)="onDropdownKeydown($event)"
            (click)="toggleDropdown()"
          >
            <img
              (error)="onImageError($event)"
              alt="User profile"
              src="assets/images/user.png"
              class="rounded-circle"
              width="30"
            />
            <span>{{ givenName }} {{ familyName }}</span>
            <img src="assets/images/down-icon.png" aria-hidden="true" />
          </a>

          <!-- Desktop dropdown: rider routes (User Profile + Settings + Sign Out) -->
          <ul class="dropdown-menu rider-dropdown-menu" [class.show]="isDropdownOpen" aria-labelledby="navbarDropdownRider" aria-label="User settings menu">
            <li>
              <button class="dropdown-item rider-dropdown-item" tabindex="0" (click)="navigateToProfile()" (keydown.enter)="navigateToProfile()" (keydown.space)="navigateToProfile()">
                <span class="rider-dropdown-link">{{ translate('user_profile') }}</span>
              </button>
            </li>
            <li>
              <button class="dropdown-item rider-dropdown-item" tabindex="0" (click)="navigateToSettings()" (keydown.enter)="navigateToSettings()" (keydown.space)="navigateToSettings()">
                <span class="rider-dropdown-link">{{ translate('settings') }}</span>
              </button>
            </li>
            <li>
              <button class="dropdown-item rider-dropdown-item" tabindex="0" (click)="handleLogout()" (keydown.enter)="handleLogout()" (keydown.space)="handleLogout()">
                <span class="rider-dropdown-link">{{ translate('sign_out') }}</span>
              </button>
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <!-- Hamburger toggler (mobile only) -->
    <button
      class="navbar-toggler d-lg-none"
      type="button"
      aria-controls="mobileMenuRider"
      [attr.aria-expanded]="isNavbarOpen"
      aria-label="Toggle navigation"
      (click)="toggleNavbar()"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
  </nav>

  <!-- Rider: Mobile menu overlay -->
  <div *ngIf="isRiderRoute" class="mobile-menu-overlay d-lg-none" [class.open]="isNavbarOpen" (click)="toggleNavbar()" aria-hidden="true"></div>

  <!-- Rider: Mobile drawer panel -->
  <div *ngIf="isRiderRoute" class="mobile-menu-panel d-lg-none" [class.open]="isNavbarOpen" id="mobileMenuRider" role="dialog" aria-label="Mobile navigation menu">
    <div class="mobile-menu-user-row">
      <div class="mobile-menu-user-info">
        <img
          (error)="onImageError($event)"
          alt="User profile"
          src="assets/images/user.png"
          class="mobile-menu-avatar"
        />
        <span class="mobile-menu-username">{{ givenName }} {{ familyName }}</span>
      </div>
      <i class="fa-solid fa-angle-down mobile-menu-chevron" aria-hidden="true"></i>
    </div>

    <nav class="mobile-menu-items" aria-label="Mobile user menu">
      <button class="mobile-menu-item" (click)="navigateToProfile(); toggleNavbar()">
        <span>{{ translate('user_profile') }}</span>
      </button>
      <button class="mobile-menu-item" (click)="navigateToSettings(); toggleNavbar()">
        <span>{{ translate('settings') }}</span>
      </button>
      <button class="mobile-menu-item" (click)="handleLogout()">
        <span>{{ translate('sign_out') }}</span>
      </button>
    </nav>
  </div>

  <!-- ===================== NON-RIDER ROUTE NAV ===================== -->
  <nav *ngIf="!isRiderRoute" class="navbar navbar-expand-lg navbar-dark bg-dark" role="navigation" aria-label="Primary Navigation">
    <a *ngIf="!isRiderRoute" class="navbar-brand">
      <img *ngIf="!isRiderRoute" class="logo" src="assets/images/e-logo.png" alt="Eligibility logo" />
    </a>

    <!-- Desktop user dropdown -->
    <div class="collapse navbar-collapse justify-content-end d-none d-lg-flex" id="navbarNavAdmin">
      <ul class="navbar-nav">
        <li class="nav-item dropdown user-container">
          <a
            style="display: flex; align-items: center;"
            class="nav-link"
            id="navbarDropdownAdmin"
            role="button"
            aria-haspopup="true"
            [attr.aria-expanded]="isDropdownOpen"
            [attr.aria-label]="'User menu for ' + givenName + ' ' + familyName"
            tabindex="0"
            (keydown)="onDropdownKeydown($event)"
            (click)="toggleDropdown()"
          >
            <img
              (error)="onImageError($event)"
              alt="User profile"
              src="assets/images/user.png"
              class="rounded-circle"
              width="30"
            />
            <span>{{ givenName }} {{ familyName }}</span>
            <img src="assets/images/down-icon.png" aria-hidden="true" />
          </a>

          <!-- Desktop dropdown: non-rider routes (Settings + Account + Logout) -->
          <ul class="dropdown-menu" [class.show]="isDropdownOpen" aria-labelledby="navbarDropdownAdmin" aria-label="User settings menu">
            <li>
              <button class="dropdown-item disabled-link" tabindex="-1">
                <i class="fas fa-cog" aria-hidden="true"></i>
                <span class="dropdown-link">Settings</span>
              </button>
            </li>
            <li>
              <button class="dropdown-item" tabindex="-1" disabled>
                <i class="fas fa-user" aria-hidden="true"></i>
                <span class="dropdown-link">Account</span>
              </button>
            </li>
            <li>
              <button class="dropdown-item" tabindex="0" (click)="handleLogout()" (keydown.enter)="handleLogout()" (keydown.space)="handleLogout()">
                <i class="fas fa-sign-out-alt" aria-hidden="true"></i>
                <span class="dropdown-link">Logout</span>
              </button>
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <!-- Hamburger toggler (mobile only) -->
    <button
      class="navbar-toggler d-lg-none"
      type="button"
      aria-controls="mobileMenuAdmin"
      [attr.aria-expanded]="isNavbarOpen"
      aria-label="Toggle navigation"
      (click)="toggleNavbar()"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
  </nav>

  <!-- Non-rider: Mobile menu overlay -->
  <div *ngIf="!isRiderRoute" class="mobile-menu-overlay d-lg-none" [class.open]="isNavbarOpen" (click)="toggleNavbar()" aria-hidden="true"></div>

  <!-- Non-rider: Mobile drawer panel -->
  <div *ngIf="!isRiderRoute" class="mobile-menu-panel d-lg-none" [class.open]="isNavbarOpen" id="mobileMenuAdmin" role="dialog" aria-label="Mobile navigation menu">
    <div class="mobile-menu-user-row">
      <div class="mobile-menu-user-info">
        <img
          (error)="onImageError($event)"
          alt="User profile"
          src="assets/images/user.png"
          class="mobile-menu-avatar"
        />
        <span class="mobile-menu-username">{{ givenName }} {{ familyName }}</span>
      </div>
      <i class="fa-solid fa-angle-down mobile-menu-chevron" aria-hidden="true"></i>
    </div>

    <nav class="mobile-menu-items" aria-label="Mobile user menu">
      <button class="mobile-menu-item mobile-menu-item--disabled" disabled>
        <span>Settings</span>
      </button>
      <button class="mobile-menu-item mobile-menu-item--disabled" disabled>
        <span>Account</span>
      </button>
      <button class="mobile-menu-item" (click)="handleLogout()">
        <span>Logout</span>
      </button>
    </nav>
  </div>

</header>
